<template>
  <header class="rsy-header" id="rsy-bdth">
    <section class="rsy-header-content">
      <div class="rsy-logo" @click="gotoHome">
        <img src="../../../assets/logo.svg" alt />
      </div>
      <div class="rsy-header-right">
        <div class="rsy-nav">
          <ul>
            <li v-for="(item, index) in navList" :key="index">
              <a
                href="javascript:void(0)"
                class="rsy-parsen"
                :class="
                  $route.path.startsWith(item.categoryListUrl) ? 'active' : ' '
                "
                @click="setcategoryList(item)"
              >
                {{ item.categoryTitle }}
                <div
                  v-if="
                    item.categoryChildEntity.length > 0 &&
                      item.categoryChildEntity[0].categoryChildMinEntity
                        .length > 0
                  "
                  class="rsy-nav-children rsy-nav-children1"
                >
                  <div
                    class="nav-item"
                    v-for="(child, index1) in item.categoryChildEntity"
                    :key="index1"
                  >
                    <h4>{{ child.categoryTitle }}</h4>
                    <a
                      href="javascript:void(0)"
                      v-for="(child1, index2) in child.categoryChildMinEntity"
                      :class="
                        $route.path === child1.categoryListUrl ? 'active1' : ' '
                      "
                      :key="index2"
                      @click.stop="setcategoryListChild(child1)"
                      >{{ child1.categoryTitle }}</a
                    >
                  </div>
                </div>
                <div
                  v-if="
                    item.categoryChildEntity.length > 0 &&
                      item.categoryChildEntity[0].categoryChildMinEntity
                        .length === 0
                  "
                  class="rsy-nav-children"
                >
                  <a
                    href="javascript:void(0)"
                    v-for="(child, index1) in item.categoryChildEntity"
                    :class="
                      $route.path === child.categoryListUrl ? 'active1' : ' '
                    "
                    :key="index1"
                    @click.stop="setcategoryListChild(child)"
                    >{{ child.categoryTitle }}</a
                  >
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </header>
</template>
<script type="text/javascript">
export default {
  props: [],
  data() {
    return {
      is_login: false,
      navList: [
        {
          categoryTitle: "首页",
          categoryListUrl: "/home",
          categoryChildEntity: []
        },
        {
          categoryTitle: "产品中心",
          categoryListUrl: "/product",
          categoryChildEntity: [
            {
              categoryTitle: "人社云",
              categoryChildMinEntity: [
                {
                  categoryTitle: "人社云精准扶弱管理系统",
                  categoryListUrl: "/product/systemsix"
                },
                {
                  categoryTitle: "人社云大数据智能分析平台",
                  categoryListUrl: "/product/systemseven"
                },
                {
                  categoryTitle: "人社云数据可视化分析平台",
                  categoryListUrl: "/product/systemeight"
                }
              ]
            },
            {
              categoryTitle: "医保云",
              categoryChildMinEntity: [
                {
                  categoryTitle: "业务经办服务智能内控系统",
                  categoryListUrl: "/product/systemone"
                },
                {
                  categoryTitle: "医保智能审核系统",
                  categoryListUrl: "/product/systemtwo"
                },
                {
                  categoryTitle: "医保基金运行分析监测系统",
                  categoryListUrl: "/product/systemthree"
                },
                {
                  categoryTitle: "医保基金画像分析系统",
                  categoryListUrl: "/product/systemfour"
                },
                {
                  categoryTitle: "医保基金监管综合执法平台",
                  categoryListUrl: "/product/systemfive"
                }
              ]
            }
          ]
        },
        {
          categoryTitle: "解决方案",
          categoryListUrl: "/plan",
          categoryChildEntity: [
            {
              categoryTitle: "人社云解决方案",
              categoryListUrl: "/plan/planone",
              categoryChildMinEntity: []
            },
            {
              categoryTitle: "医保云解决方案",
              categoryListUrl: "/plan/plantwo",
              categoryChildMinEntity: []
            }
            // { title: "商保云解决方案", path: "/plan/planthree" },
          ]
        },
        {
          categoryTitle: "关于我们",
          categoryListUrl: "/pcuser",
          categoryChildEntity: [
            // { title: "关于社宝", path: "/pcuser/aboutone" },
            // { title: "关于人社云", path: "/pcuser/abouttwo" },
            // { title: "公司地址", path: "/pcuser/aboutthree" },
          ]
        },
        {
          categoryTitle: "云生集团",
          categoryListUrl: "http://www.shebaochina.com/",
          categoryChildEntity: []
        }
      ],
      navIndex: 0
    };
  },
  watch: {
    // $route() {
    //   // 获取当前路径
    //   let path = this.$route.path;
    //   // if(path ==='')
    //   // 检索当前路径
    //   this.checkRouterLocal(path);
    // },
  },
  create() {},
  mounted() {},
  methods: {
    setcategoryList(data) {
      if (data.categoryChildEntity.length === 0) {
        this.$store.dispatch("navId", data.id); //储存导航栏id
        this.$store.dispatch("categoryFlag", data.categoryFlag); //储存导航栏属性
        this.$store.dispatch("categoryId", data.categoryId); //储存导航栏父类型id
      } else {
        this.$store.dispatch("navId", data.categoryChildEntity[0].id); //储存导航栏id
        this.$store.dispatch(
          "categoryFlag",
          data.categoryChildEntity[0].categoryFlag
        ); //储存导航栏属性
        this.$store.dispatch(
          "categoryId",
          data.categoryChildEntity[0].categoryId
        ); //储存导航栏父类型id
      }
      if (data.categoryListUrl.indexOf("http://") > -1) {
        const url = data.categoryListUrl;
        window.open(url, "_blank");
        // window.location.href = "http://www.shebaochina.com";
      } else {
        this.$router.push(data.categoryListUrl);
      }
    },
    setcategoryListChild(child) {
      this.$store.dispatch("navId", child.id); //储存导航栏父类型id
      this.$store.dispatch("categoryFlag", child.categoryFlag); //储存导航栏属性
      this.$store.dispatch("categoryId", child.categoryId); //储存导航栏父类型id
      this.$router.push(child.categoryListUrl);
    },
    //检索当前路径
    checkRouterLocal(path) {
      // 查找当前路由下标高亮

      this.navIndex = this.nav.findIndex(item => item.path === path);
    },
    submit_search(value) {
      this.$message.success(value);
    },
    gotoHome() {
      this.$router.push("/home");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/header.scss";
</style>



// WEBPACK FOOTER //
// src/components/mainContent/headerSection/index.vue